import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { stripPhone } from '../utils/phone.util';

export function tenDigitPhoneValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const val = stripPhone(control.value);
    if (!val) return null; 
    return val.length === 10 ? null : { invalidPhone: true };
  };
}
